/** Modo vendedor → partner: entrega en persona o envío al local. */
export const SELLER_TO_PARTNER_MODES = [
  {
    value: 'physical',
    label: 'Entrega física al partner',
    desc: 'Llevarás el disco en persona al local del partner.',
  },
  {
    value: 'shipping',
    label: 'Envío al partner',
    desc: 'Enviarás el paquete por mensajería a la dirección del partner.',
  },
];

export const PARTNER_LOGISTICS_DEFAULTS = {
  seller_dropoff_physical: true,
  seller_dropoff_shipment: true,
  buyer_handover_physical: true,
  buyer_outbound_shipment: false,
};

export function logisticsFromRoleData(roleData) {
  const raw = roleData?.logistics && typeof roleData.logistics === 'object' ? roleData.logistics : {};
  return {
    seller_dropoff_physical:
      raw.seller_dropoff_physical ?? PARTNER_LOGISTICS_DEFAULTS.seller_dropoff_physical,
    seller_dropoff_shipment:
      raw.seller_dropoff_shipment ?? PARTNER_LOGISTICS_DEFAULTS.seller_dropoff_shipment,
    buyer_handover_physical:
      raw.buyer_handover_physical ?? PARTNER_LOGISTICS_DEFAULTS.buyer_handover_physical,
    buyer_outbound_shipment:
      raw.buyer_outbound_shipment ?? PARTNER_LOGISTICS_DEFAULTS.buyer_outbound_shipment,
  };
}

export function sellerModeLabel(mode) {
  if (mode === 'shipping') return 'Envío al partner';
  if (mode === 'physical') return 'Entrega física al partner';
  return '';
}

/** @returns {{ physical: boolean, shipping: boolean }} */
export function sellerModesFromListingRow(row, role) {
  const plural =
    role === 'store'
      ? row?.seller_to_partner_modes_store ?? row?.sellerToPartnerModesStore
      : row?.seller_to_partner_modes_pickup ?? row?.sellerToPartnerModesPickup;
  if (Array.isArray(plural) && plural.length) {
    return {
      physical: plural.includes('physical'),
      shipping: plural.includes('shipping'),
    };
  }
  const single =
    role === 'store'
      ? row?.seller_to_partner_mode_store ?? row?.sellerToPartnerModeStore
      : row?.seller_to_partner_mode_pickup ?? row?.sellerToPartnerModePickup;
  const m = String(single || 'physical').trim();
  return { physical: m === 'physical', shipping: m === 'shipping' };
}

/** @param {{ physical: boolean, shipping: boolean }} modes */
export function sellerModesToArray(modes) {
  const out = [];
  if (modes?.physical) out.push('physical');
  if (modes?.shipping) out.push('shipping');
  return out.length ? out : ['physical'];
}
